import { prependPathWithParams } from '@dhl/utils'

import { shipmentLinks } from '~/basket/view/links'
import { servicepointLinks } from '~/servicepoint/links'
import { addressBookLinks } from '~/address-book/view/links'
import { dashboardLinks } from '~/dashboard/view/links'
import { reportLinks } from '~/report/links'
import { profileLinks } from '~/profile/view/links'
import { delayedPaymentLinks } from '~/basket/view/pages/payment/links'

export const PATH = {
  ROOT_PWA: 'pwa',
  ROOT_OTC: 'otc',
  ROOT_PLACEHOLDER: ':root',
  ACCOUNT: 'account',
  BASKET: 'shipment',
  SERVICEPOINT: 'servicepoint-locator',
  ADDRESS_BOOK: 'address',
  DASHBOARD: 'dashboard',
  SUMMARY: 'summary',
  REPORT: 'report',
  PRINTLESS: 'printless',
  PROFILE: 'profile',
  DELAYED_PAYMENT: 'payment',
}

export const EXTERNAL_PATHS = {
  PORTAL: 'portal',
  PORTAL_DASHBOARD: 'portal/dashboard',
  PORTAL_INCOMING_PIECES: 'portal/shipments/incoming',
  PORTAL_OUTGOING_PIECES: 'portal/shipments/outgoing',
  PORTAL_MORE: 'portal/more',
  PORTAL_PROFILE: 'portal/profile',
  HOME_MORE: 'home/more',
  SPA: 'servicepoint/',
  SPA_INVENTORY: 'servicepoint/inventory/courier_hand_out_ready',
  ACCOUNT_APP_SIGN_IN: 'account/sign-in',
  ONBOARDING: 'home/',
  ONBOARDING_DASHBOARD: 'home/dashboard',
  ONBOARDING_INCOMING_PIECES: 'home/shipments/incoming',
  ONBOARDING_OUTGOING_PIECES: 'home/shipments/outgoing',
  ONBOARDING_TRACK_TRACE: 'home/tracktrace',
  ONBOARDING_MORE: 'home/more',
}

const externalLinks = {
  portalLink: () => `/${EXTERNAL_PATHS.PORTAL}`,
  portalDashboardLink: () => `/${EXTERNAL_PATHS.PORTAL_DASHBOARD}`,
  portalIncomingPiecesLink: () => `/${EXTERNAL_PATHS.PORTAL_INCOMING_PIECES}`,
  portalOutgoingPiecesLink: () => `/${EXTERNAL_PATHS.PORTAL_OUTGOING_PIECES}`,
  portalMoreLink: () => `/${EXTERNAL_PATHS.PORTAL_MORE}`,
  portalProfileLink: () => `/${EXTERNAL_PATHS.PORTAL_PROFILE}`,
  homeMoreLink: () => `/${EXTERNAL_PATHS.HOME_MORE}`,
  spaLink: () => `/${EXTERNAL_PATHS.SPA}`,
  spaInventoryLink: () => `/${EXTERNAL_PATHS.SPA_INVENTORY}`,
  accountSignInLink: () => `/${EXTERNAL_PATHS.ACCOUNT_APP_SIGN_IN}`,
  rootLink: () => '/',
  onboardingLink: () => `/${EXTERNAL_PATHS.ONBOARDING}`,
  onboardingDashboardLink: () => `/${EXTERNAL_PATHS.ONBOARDING_DASHBOARD}`,
  onboardingIncomingPiecesLink: () => `/${EXTERNAL_PATHS.ONBOARDING_INCOMING_PIECES}`,
  onboardingOutgoingPiecesLink: () => `/${EXTERNAL_PATHS.ONBOARDING_OUTGOING_PIECES}`,
  onboardingTrackTraceLink: (trackingCode?: string, postalCode?: string) => {
    const path = [EXTERNAL_PATHS.ONBOARDING_TRACK_TRACE, trackingCode, postalCode].filter(Boolean).join('/')
    return `/${path}`
  },
  onboardingMoreLink: () => `/${EXTERNAL_PATHS.ONBOARDING_MORE}`,
}

export const links = {
  ...externalLinks,
  ...prependPathWithParams(() => PATH.BASKET, shipmentLinks),
  ...prependPathWithParams(() => PATH.SERVICEPOINT, servicepointLinks),
  ...prependPathWithParams(() => PATH.ADDRESS_BOOK, addressBookLinks),
  ...prependPathWithParams(() => PATH.DASHBOARD, dashboardLinks),
  ...prependPathWithParams(() => PATH.REPORT, reportLinks),
  ...prependPathWithParams(() => PATH.PROFILE, profileLinks),
  ...prependPathWithParams(() => PATH.DELAYED_PAYMENT, delayedPaymentLinks),
}
